<template>
  <Modal
    class="tw-max-w-[1040px]"
    :visible="showRef"
    @close="() => handleCloseModal(false)"
  >
    <ModalHeader
      :title="getComponentUiText('app-modal-manage-vendor-title-1')"
      :class="'tw-px-[20px] sm:tw-px-[40px]'"
      @close="() => handleCloseModal(true)"
    />
    <div
      :class="`tw-px-[20px] tw-pb-[40px] sm:tw-px-[40px] tw-pt-[20px] sm:tw-pt-[40px] tw-flex tw-flex-col tw-gap-10 tw-w-full`"
    >
      <!-- Vendor Detail -->
      <div
        class="tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-text-[#211F58] tw-w-full"
      >
        <div class="tw-relative tw-w-full">
          <div class="tw-text-[16px] tw-leading-[130%] tw-font-semibold">
            {{ getComponentUiText("app-modal-manage-vendor-details-title-1") }}
            <ButtonShowDuplicateAssessment
              :id-popover="'popover-vendor-current-details'"
              :custom-class="'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]'"
              :classes="`!tw-leading-none tw-ml-[10px]`"
            >
            </ButtonShowDuplicateAssessment>
          </div>
          <div
            class="tw-pr-[20px] tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]"
          >
            {{
              getComponentUiText("app-modal-manage-vendor-details-decription-1")
            }}
          </div>
        </div>

        <div class="tw-relative tw-w-full tw-flex tw-flex-col tw-gap-[20px]">
          <BaseInput
            id="name"
            v-model="formModel.name"
            :validation="$v.name"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px] tw-text-[#231F20]'"
            data-cy-id="vendor-name-input"
            :input-class="'!tw-h-[56px]'"
            :label="getComponentUiText('app-modal-manage-vendor-name-title-1')"
            :placeholder="
              getComponentUiText('app-modal-manage-vendor-name-placeholder-1')
            "
            @blur="
              () => {
                $v.name.$validate();
              }
            "
          >
          </BaseInput>
          <BaseInput
            id="url"
            v-model="formModel.url"
            :validation="$v.url"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px] tw-text-[#231F20]'"
            data-cy-id="vendor-url-input"
            :input-class="'!tw-h-[56px]'"
            :label="
              getComponentUiText(
                'app-modal-manage-vendor-current-vendor-table-url-title-1',
              ).toLocaleUpperCase()
            "
            :placeholder="
              getComponentUiText(
                'app-modal-manage-vendor-input-support-url-placeholder-1',
              )
            "
            @blur="() => {}"
          >
          </BaseInput>
          <BaseInput
            id="phone"
            v-model="formModel.phone"
            :validation="$v.phone"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px] tw-text-[#231F20]'"
            data-cy-id="vendor-phone-input"
            :input-class="'!tw-h-[56px]'"
            :label="
              getComponentUiText('app-modal-manage-vendor-input-phone-title-1')
            "
            :placeholder="
              getComponentUiText(
                'app-modal-manage-vendor-input-support-phone-placeholder-1',
              )
            "
            @blur="() => {}"
          >
          </BaseInput>
          <BaseInput
            id="supportUrl"
            v-model="formModel.urlSupport"
            :validation="$v.urlSupport"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px] tw-text-[#231F20]'"
            data-cy-id="vendor-support-url-input"
            :input-class="'!tw-h-[56px]'"
            :label="
              getComponentUiText(
                'app-modal-manage-vendor-input-support-url-title-1',
              )
            "
            :placeholder="
              getComponentUiText(
                'app-modal-manage-vendor-input-support-url-placeholder-1',
              )
            "
            @blur="() => {}"
          >
          </BaseInput>
          <BaseInput
            id="supportPhone"
            v-model="formModel.phoneSupport"
            :validation="$v.phoneSupport"
            :container="'tw-w-full '"
            :class-name="'!tw-items-center !tw-mt-[0px] tw-text-[#231F20]'"
            data-cy-id="vendor-support-phone-input"
            :input-class="'!tw-h-[56px]'"
            :label="
              getComponentUiText(
                'app-modal-manage-vendor-input-support-phone-title-1',
              )
            "
            :placeholder="
              getComponentUiText(
                'app-modal-manage-vendor-input-support-phone-placeholder-1',
              )
            "
            @blur="() => {}"
          >
          </BaseInput>
        </div>
        <BaseInput
          id="description"
          v-model="formModel.description"
          :validation="$v.description"
          :container="'tw-w-full '"
          :class-name="'!tw-mt-[0px] tw-text-[#231F20]'"
          :label-class="'sm:tw-mt-[9px]'"
          :input-class="'!tw-h-[56px]'"
          :label="
            getComponentUiText(
              'app-modal-manage-vendor-current-vendor-table-description-title-1',
            )
          "
          :placeholder="
            getComponentUiText(
              'app-modal-manage-vendor-description-placeholder-1',
            )
          "
          @blur="() => {}"
        >
          <WysiwygEditor
            v-model="formModel.description"
            :placeholder="
              getComponentUiText(
                'app-modal-manage-vendor-description-placeholder-1',
              )
            "
            data-cy-id="vendor-description-input"
            :include-image="false"
            :is-disabled="false"
          />
        </BaseInput>
        <BaseInput
          id="notes"
          v-model="formModel.notes"
          :validation="$v.notes"
          :container="'tw-w-full '"
          :class-name="'!tw-mt-[0px] tw-text-[#231F20] !tw-items-start'"
          :label-class="'sm:tw-mt-[9px]'"
          :input-class="'!tw-h-[56px]'"
          :label="getComponentUiText('app-modal-manage-vendor-notes-title-1')"
          :placeholder="
            getComponentUiText(
              'app-vendor-dropdown-placehoder-base-input-name-1',
            )
          "
          @blur="() => {}"
        >
          <WysiwygEditor
            v-model="formModel.notes"
            :placeholder="
              getComponentUiText('app-modal-manage-vendor-notes-placeholder-1')
            "
            data-cy-id="vendor-notes-input"
            :include-image="false"
            :is-disabled="false"
          />
        </BaseInput>
      </div>
      <div
        class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-w-full"
      >
        <div>
          <button
            v-if="vendorEdit.id"
            data-cy="create-and-upate-assessment-create-btn"
            :class="`tw-flex tw-items-center tw-h-[39px] tw-px-[18px] tw-gap-2.5 tw-rounded-[26.909px] tw-bg-[#F7553C] tw-text-white tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%]
            hover:tw-bg-[#d84d37] ${
              isLoadingDelete ? 'tw-overflow-hidden' : 'tw-py-3'
            } createBtn`"
            @click="() => handleDeleteVendor(vendorEdit)"
          >
            <LottieAnimation
              v-if="isLoadingDelete"
              :class="'tw-h-[39px] tw-w-[39px] tw-absolute tw-left-[62px]'"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
            <div :class="`${isLoadingDelete ? 'tw-mt-[60px]' : ''}`">
              {{
                getComponentUiText(
                  "app-modal-manage-vendor-button-delete-title-1",
                )
              }}
            </div>
          </button>
        </div>

        <div class="tw-flex tw-flex-row tw-justify-end tw-items-center">
          <b-button
            style="line-height: 100%; border: 2px solid; height: 39px"
            variant="primary"
            class="tw-w-fit tw-mr-[10px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
            type="submit"
            @click="handleResetAndCloseForm"
          >
            {{
              getComponentUiText(
                "app-modal-manage-vendor-button-cancel-title-1",
              )
            }}
          </b-button>
          <button
            data-cy="create-and-upate-assessment-create-btn"
            :class="`tw-h-[39px] tw-px-[18px] tw-gap-2.5 tw-rounded-[26.909px] tw-bg-[#387DFF] tw-text-white tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%]
              hover:tw-bg-[#096cdb] ${
                isLoading ? 'tw-overflow-hidden' : 'tw-py-3'
              } createBtn`"
            @click="handleSubmitVendor"
          >
            <LottieAnimation
              v-if="isLoading"
              :class="'tw-h-[39px] tw-w-[39px] tw-absolute'"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
            <div :class="`${isLoading ? 'tw-mt-[39px]' : ''}`">
              {{
                getComponentUiText(
                  "app-modal-manage-vendor-button-save-title-1",
                )
              }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import {
  getComponentUiText,
  hasInvalidDomainChars,
  invalidCharPhoneNumber,
  IsPhoneNumber,
  isUrlFacingWeb,
} from "../../utils/utilities";
import { computed, onMounted, Ref, ref, watch } from "vue";
import ModalHeader from "../common/modalHeader.vue";
import Modal from "../common/modal.vue";
import BaseInput from "../common/form/baseInput.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import WysiwygEditor from "../common/wysiwygEditor.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import store from "@/store";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import { ARE_YOU_SURE_TYPES, MODAL_NAME } from "@/utils/constants";
import { IVendorProvider } from "@/interfaces/vendor";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
  },
  data: {
    type: Object,
    required: true,
    default: () => ({
      name: "",
      description: "",
      url: "",
      phone: "",
      urlSupport: "",
      phoneSupport: "",
      notes: "",
    }),
  },
});
const emit = defineEmits(["update:show", "update:data", "update:close"]);

let showRef = ref(props.show);

const searchValue = ref("");
const isShowVendorDetails = ref(false);
const seletedAssessmentRow = ref([]);
const isLoading = ref(false);
const isLoadingDelete = ref(false);
const formModel = ref(props.data);

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  description: {},
  url: {
    url: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url) => isUrlFacingWeb(url) || !url,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url: string) => hasInvalidDomainChars(url) || !url,
    ),
  },
  phone: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => IsPhoneNumber(phone) || !phone,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => invalidCharPhoneNumber(phone) || !phone,
    ),
  },
  urlSupport: {
    url: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url) => isUrlFacingWeb(url) || !url,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url: string) => hasInvalidDomainChars(url) || !url,
    ),
  },
  phoneSupport: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => IsPhoneNumber(phone) || !phone,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => invalidCharPhoneNumber(phone) || !phone,
    ),
  },
  notes: {},
};

const $v = useVuelidate(rules, formModel as any);
const vendorEdit: Ref<IVendorProvider> = ref({});

onMounted(() => {});

const handleCloseModal = (fromModal) => {
  if (!fromModal) {
    const check = checkInputField();
    if (check) return;
  }
  showRef.value = false;
  emit("update:show", showRef.value);
};

const checkInputField = () => {
  return Object.entries(formModel.value).filter(([key, value]) =>
    !vendorEdit.value?.id
      ? value
      : value !== vendorEdit.value[key] && (value || vendorEdit.value[key]),
  ).length;
};

const handleResetAndCloseForm = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
  vendorEdit.value = {};
  formModel.value = {
    name: "",
    description: "",
    url: "",
    phone: "",
    urlSupport: "",
    phoneSupport: "",
    notes: "",
  };
  $v.value.$reset();
};

const handleSubmitVendor = async () => {
  try {
    isLoading.value = true;
    const isValid = await $v.value.$validate();
    if (!isValid) {
      return;
    }

    const vendorData: { [k: string]: string | number } = Object.fromEntries(
      Object.entries(formModel.value).filter(([key, value]) =>
        !vendorEdit.value?.id
          ? value
          : value !== vendorEdit.value[key] && (value || vendorEdit.value[key]),
      ),
    );
    if (!Object.entries(vendorData).length) {
      handleCloseModal(false);
      return;
    }
    if (vendorEdit.value?.id) {
      vendorData.id = vendorEdit.value.id;
    }

    const res = await store.dispatch("Vendor/addProvider", vendorData);
    if (res) {
      handleResetAndCloseForm();
    }
  } catch (error) {
    console.error("Error submitting vendor data:", error);
  } finally {
    isLoading.value = false;
  }
};

const handleDeleteVendor = async (item: IVendorProvider) => {
  try {
    isLoadingDelete.value = true;
    const res = await store.dispatch("Vendor/deleteProvider", item.id);
    if (res && item.id === vendorEdit.value.id) {
      handleCloseModal(false);
    }
  } catch (error) {
    console.error("Error delete vendor data:", error);
  } finally {
    isLoadingDelete.value = false;
  }
};

const onSelectVendor = (selectedRows: any) => {
  seletedAssessmentRow.value = selectedRows;
};

const onEditVendor = (item: IVendorProvider) => {
  isShowVendorDetails.value = true;
  vendorEdit.value = item;
  formModel.value = {
    name: item.name ?? "",
    description: item.description ?? "",
    url: item.url ?? "",
    phone: item.phone ?? "",
    urlSupport: item.urlSupport ?? "",
    phoneSupport: item.phoneSupport ?? "",
    notes: item.notes ?? "",
  };
};

const onDeleteVendor = (item: IVendorProvider) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-modal-manage-vendor-modal-delete-vendor-title-1",
      ),
      description: getComponentUiText(
        "app-modal-manage-vendor-delete-vendor-description-1",
      ),
      list: [],
      buttonText: getComponentUiText(
        "app-modal-manage-vendor-delete-vendor-button-title-1",
      ),
      isShowBtnCancel: true,
      blueText: getComponentUiText(
        "app-modal-manage-vendor-modal-delete-vendor-cancel-button-title-1",
      ),
      buttonRed: true,
      hiddenHelp: false,
      type: ARE_YOU_SURE_TYPES.assessmentTemplateDelete,
      updateDataFunction: async () => {
        const res = await store.dispatch("Vendor/deleteProvider", item.id);
        // if (res && item.id === vendorEdit.value.id) {
        //   handleResetAndCloseForm();
        // }
      },
    },
    events: {
      "update:data": async () => {
        store.dispatch(
          "LoadingAreYouSureButtonModal/setLoadingRedButton",
          true,
        );
        const res = await store.dispatch("Vendor/deleteProvider", item.id);
        if (res && item.id === vendorEdit.value.id) {
          handleResetAndCloseForm();
        }
        store.dispatch(
          "LoadingAreYouSureButtonModal/setLoadingRedButton",
          false,
        );
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

watch(
  () => props.data,
  (item) => {
    vendorEdit.value = item;
    formModel.value = {
      name: item.name ?? "",
      description: item.description ?? "",
      url: item.url ?? "",
      phone: item.phone ?? "",
      urlSupport: item.urlSupport ?? "",
      phoneSupport: item.phoneSupport ?? "",
      notes: item.notes ?? "",
    };
  },
  {
    immediate: true,
  },
);
</script>

<style scoped lang="scss">
:deep(.ck .ck-placeholder:before) {
  color: #b7b7b7 !important;
}

.modal-add-domain input::placeholder {
  font-size: 15px !important;
}
.show-password-label {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: right;
}
</style>
